import { useEffect, useState } from 'react';
import { useGeneralRoutes, useOtherSettings } from '@namespace/cms';
import {
  getSessionStorageValue,
  SESSION_STORAGE_KEYS
} from '@namespace/helpers';
import { useLocation } from '@namespace/i18n';
import { useGetCurrentCurrency } from '@namespace/user';
import { useGetPaymentConfigSWRequest } from '../useGetPaymentConfigSWRequest';

const normalizePathname = (path: string) =>
  path.endsWith('/') ? path.slice(0, -1) : path;

export const useGetPaymentsConfigSW = () => {
  const [isInitialConfigLoaded, setIsInitialConfigLoaded] = useState(false);

  const { pathname } = useLocation();
  const { isNeedSetupDepositLimitCheck } = useOtherSettings();
  const updateSWConfig = useGetPaymentConfigSWRequest();
  const currency = useGetCurrentCurrency();
  const { deposit, withdraw, historyDeposits, historyWithdrawals } =
    useGeneralRoutes();

  const balancePages = [deposit, withdraw, historyDeposits, historyWithdrawals];

  useEffect(() => {
    if (currency) {
      updateSWConfig();
      setIsInitialConfigLoaded(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currency]);

  useEffect(() => {
    if (!isNeedSetupDepositLimitCheck || !isInitialConfigLoaded) {
      return;
    }
    const isBalancePage = balancePages.includes(normalizePathname(pathname));
    const prevPathname = getSessionStorageValue(
      SESSION_STORAGE_KEYS.PREV_PATHNAME,
      ''
    );
    const isUpdateConfigRequired = !balancePages.includes(
      normalizePathname(prevPathname)
    );

    if (isBalancePage && isUpdateConfigRequired) {
      updateSWConfig();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
};
